import { Typography } from "@mui/material";
import ServiceItemCard from "./ServiceItemCard";

const UtilityItemsList = ({
  utilityItems,
  language,
  selectedUtilityItems,
  utilityQuantities,
  onUtilityToggle,
  onQuantityChange
}) => {
  if (!utilityItems || utilityItems.length === 0) {
    return null;
  }

  const isUtilitySelected = (itemId) => {
    return selectedUtilityItems.some((u) => u._id === itemId);
  };

  const getUtilityQuantity = (itemId) => {
    return utilityQuantities[itemId] || 0;
  };

  return (
    <div className="section-container" style={{ marginTop: "30px" }}>
      <Typography variant="h6" component="h3" className="section-title">
        {language === "ar" ? "مستلزمات قد تحتاجها" : "Items You May Need"}
      </Typography>

      <div className="services-list">
        {utilityItems.map((item) => (
          <ServiceItemCard
            key={item._id}
            item={item}
            isUtility={true}
            isSelected={isUtilitySelected(item._id)}
            quantity={getUtilityQuantity(item._id)}
            language={language}
            onToggle={onUtilityToggle}
            onQuantityChange={onQuantityChange}
          />
        ))}
      </div>
    </div>
  );
};

export default UtilityItemsList;